/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ column: NonNullable<unknown> }} Toast_MovedInputs */

const en_toast_moved = /** @type {(inputs: Toast_MovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Moved to ${i?.column}`)
};

const de_toast_moved = /** @type {(inputs: Toast_MovedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nach ${i?.column} verschoben`)
};

/**
* | output |
* | --- |
* | "Moved to {column}" |
*
* @param {Toast_MovedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_moved = /** @type {((inputs: Toast_MovedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_MovedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_toast_moved(inputs)
	return en_toast_moved(inputs)
});